// @ts-expect-error no types for this file
import { DispatcherInstance } from 'general-store';
// @ts-expect-error no types for this file
import dispatcher from 'dispatcher/dispatcher';
// @ts-expect-error no types for this file
import { authLoaded } from 'crm_data/auth/AuthActions';
DispatcherInstance.set(dispatcher);
export const setupData = auth => {
  // PreviewHighlight requires stores based on RecordsUI implementation.
  // thread: https://hubspot.slack.com/archives/C74P0T492/p1695922151054859
  require('crm_data/gates/IsUngatedStore');
  require('crm_data/user/UserStore');
  authLoaded(auth);
};